import { QueryClient, useQuery, UseQueryResult } from '@tanstack/react-query';

import { TypedDocumentNode } from '@graphql-typed-document-node/core';
import request from 'graphql-request';
import { useRouter } from 'next/router';

export function useGraphQLQuery<TResult, TVariables>(
  document: TypedDocumentNode<TResult, TVariables>,
  ...[variables]: TVariables extends Record<string, never> ? [] : [TVariables]
): UseQueryResult<TResult> {
  const { isReady } = useRouter();

  return useQuery([(document.definitions[0] as any).name.value, variables], {
    queryFn: async ({ queryKey }) =>
      request(
        process.env.GRAPHQL_API_URL as string,
        document,
        queryKey[1] ? queryKey[1] : undefined,
        {},
      ),
    enabled: isReady,
  });
}

export async function fetchGraphQLQuery<TResult, TVariables>(
  document: TypedDocumentNode<TResult, TVariables>,
  ...[variables]: TVariables extends Record<string, never> ? [] : [TVariables]
): Promise<TResult> {
  const queryClient = new QueryClient();

  console.log('Fetching GraphQL query:', document);

  return await queryClient.fetchQuery(
    [(document.definitions[0] as any).name.value, variables],
    async ({ queryKey }) =>
      request(
        process.env.GRAPHQL_API_URL as string,
        document,
        queryKey[1] ? queryKey[1] : undefined,
      ),
  );
}
